import { FnAxiosInstance } from '../axios/axios';

export const getAutomationPendingConfirmation = async (beneId: number) => {
  const url = `beneficiary/mailing-address/pending/${beneId}`;
  const response = await FnAxiosInstance.get(url);
  return response?.data || [];
};
